<template>
    <div class="bg-white shadow p-6 rounded">
        <div v-if="formSuccess">
            Tak for din henvendelse. Vi kontakter dig snarest!
        </div>
        <div v-else>
            <div class="lg:flex lg:flex-wrap lg:-mx-4">
                <div class="lg:w-1/2 lg:px-4 mb-4">
                    <label class="text-xs font-semibold">Navn *</label>
                    <input v-model="form.name" class="w-full py-2 px-4 rounded bg-white border bg-lightgray" />
                </div>
                <div class="lg:w-1/2 lg:px-4 mb-4">
                    <label class="text-xs font-semibold">Virksomhed *</label>
                    <input v-model="form.company" class="w-full py-2 px-4 rounded bg-white border bg-lightgray" />
                </div>
                <div class="lg:w-1/2 lg:px-4 mb-4">
                    <label class="text-xs font-semibold">Telefon *</label>
                    <input v-model="form.phone" class="w-full py-2 px-4 rounded bg-white border bg-lightgray" />
                </div>
                <div class="lg:w-1/2 lg:px-4 mb-4">
                    <label class="text-xs font-semibold">E-mail *</label>
                    <input v-model="form.email" class="w-full py-2 px-4 rounded bg-white border bg-lightgray" />
                </div>
                <div class="w-full lg:px-4 mb-4">
                    <label class="text-xs font-semibold">Besked *</label>
                    <textarea v-model="form.message" class="w-full py-2 px-4 rounded bg-white border bg-lightgray" rows="6"></textarea>
                </div>
                <div class="w-full lg:px-4">
                    <button @click="submit()" :class="{'bg-gray-300 cursor-not-allowed': !formValidated || loading, 'bg-deveo hover:bg-lightblue': formValidated && !loading}" class="text-xs lg:text-sm w-full py-2 px-4 rounded text-white text-center font-semibold transition duration-300 outline-none focus:outline-none" style="outline:none;">
                        <span v-if="loading">
                            Sender...
                        </span>
                        <span v-else>
                            Skriv til os
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            formSuccess: false,
            loading: false,
            form: {
                name: '',
                company: '',
                phone: '',
                email: '',
                message: ''
            }
        }
    },
    methods: {
        submit () {
            // Do validation
            if (this.loading) {
                return
            }
            if (!this.formValidated) {
                alert('Du mangler at udfylde et eller flere felter. Prøv venligst igen.')
                return
            }
            this.loading = true
            const url = '/api/contact-form'
            const params = this.form
            axios.get(url, {params})
                .then((response) => {
                    this.formSuccess = true
                    this.loading = false
                })
                .catch((err) => {
                    alert('Der skete en fejl ved indsendelse af formularen. Prøv venligst igen senere eller skriv direkte til os på kontakt@n3rdz.dk')
                    console.log(err)
                    this.loading = false
                })
        }
    },
    computed: {
        formValidated () {
            if (this.form.name === '') { return false }
            if (this.form.company === '') { return false }
            if (this.form.phone === '') { return false }
            if (this.form.email === '') { return false }
            if (this.form.message === '') { return false }
            return true
        }
    }
}
</script>